<template>
  <header class="app-header">
    <div class="left-wrap">
      <button v-if="!isMainPage" type="button" class="back-btn" @click="goBack">
        <img :src="getAssetImageUrl('common/icons/back-arrow.svg')" alt="" />
      </button>

      <h1>{{ title }}</h1>
    </div>

    <div class="right-wrap">
      <button
        v-if="userStore.userInfo?.userType === 'HOST'"
        class="credit-btn"
        aria-label="credit"
        @click="goToPage('app-credit')"
      >
        <img :src="getAssetImageUrl('common/icons/credit-icon.svg')" alt="credit" />
        <span>{{ formatNumberWithComma(subscriptionStore.currentCredits) }}</span>
      </button>

      <IconHamburger class="icon" @click="goToPage('app-setting')" />
    </div>
  </header>
</template>

<script setup lang="ts">
import IconHamburger from '@/components/jh-app/icons/IconHamburger.vue';
import { setIsBack } from '@/router';
import { useSubscriptionStore } from '@/stores/subscription';
import { useUserStore } from '@/stores/user';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';
import { formatNumberWithComma } from '@/utils/stringUtils.js';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const userStore = useUserStore();
const subscriptionStore = useSubscriptionStore();

const intervalId = ref<number>();

const title = computed(() => {
  const metaTitle = route.meta.title;

  if (typeof metaTitle === 'function') {
    return metaTitle(route);
  }
  if (typeof metaTitle === 'string') {
    return t(metaTitle);
  }

  return '';
});
const isMainPage = computed(() => route.path.includes('main'));

const setupSubscriptionInterval = async () => {
  intervalId.value = setInterval(async () => {
    await subscriptionStore.fetchSubscriptionInfo();
  }, 300000);
};

const goBack = () => {
  const back = router.options.history.state.back;

  if (!back) {
    router.replace({ name: 'app-main-view' });
    return;
  }

  const destinationBack = String(back);
  const isDestinationLogin = destinationBack.includes('login');
  const isDestinationOnboarding = destinationBack.includes('onboarding');

  if (isDestinationLogin || isDestinationOnboarding) {
    router.replace({ name: 'app-main-view' });
    return;
  }

  setIsBack(true);
  router.back();
};

const goToPage = (name) => {
  router.push({ name });
};

onBeforeMount(async () => {
  await subscriptionStore.initializeSubscriptionInfo();
  // await setupSubscriptionInterval();
});

onUnmounted(() => {
  clearInterval(intervalId.value);
});
</script>

<style scoped lang="scss"></style>
